import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
import { HEADER, NAVBAR } from '../../config';
// import { toast } from 'react-toastify';
// import { getMessaging, onMessage } from 'firebase/messaging';
// import { useAppDispatch } from '../../store';
// import { setStatus as setNotifcationStatus } from '../../store/notification/notificationSlice';

const APP_BAR_MOBILE = 64;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const MainStyle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})<any>(({ theme, collapseClick }: any) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  background: '#ffedf5',
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    }),
  },
}));

export default function DashboardLayout() {
  // const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const {
    collapseClick,
    isCollapse = false,
  }: {
    collapseClick: any;
    isCollapse?: boolean;
  } = useCollapseDrawer();

  // const handleRedirect = (data: Notification) => {
  //   if (data?.title === 'New Order Placed') {
  //     navigate('/order');
  //   }
  // };

  // useEffect(() => {
  //   if (typeof window?.navigator?.serviceWorker !== 'undefined') {
  //     onMessage(getMessaging(), (payload: any) => {
  //       if (payload.data) {
  //         dispatch(setNotifcationStatus({ status: 'idle' }));
  //         toast.info(
  //           <div onClick={() => handleRedirect(payload.data)}>
  //             <h5>{payload.data.title}</h5>
  //             <span>{payload.data.message}</span>
  //           </div>,
  //           { autoClose: 5000 }
  //         );
  //       }
  //     });
  //   }
  // });

  return (
    <RootStyle>
      <DashboardNavbar
        onOpenSidebar={() => setOpen(true)}
        isCollapse={isCollapse}
      />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />
      <MainStyle collapseClick={collapseClick}>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
